import { PointerActivationConstraints, PointerSensor } from "@skilitics/drag-drop";

/**
 * A configured PointerSensor that:
 * - Prevents drag activation from interactive elements (inputs, textareas) on the canvas
 * - Requires 3px of movement before activating
 */
export const ClickShieldMouseSensor = PointerSensor.configure({
  activationConstraints: [new PointerActivationConstraints.Distance({ value: 3 })],
  preventActivation: (event: PointerEvent) => {
    return event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement;
  },
});
